import React, { useCallback } from 'react';
// Material
import { Grid, TextField, Button } from '@mui/material';
import ButtonWithLoader from 'commons/containers/ButtonWithLoader';
// Icons
import FileDownloadIcon from '@mui/icons-material/FileDownload';
// Utils
import { useForm } from 'utils/hooks/useForm';
import { isNumber } from 'utils/math';
import { numberBetween, valueHasData } from 'utils/validationsHelper';
import { downloadHistoric } from 'utils/xlsx';
import SearchMaterialByName from 'commons/components/SearchMaterialByName';
import SearchClientByName from 'commons/components/SearchClientByName';

const HistoricFilters = function (props) {
  const { controls, actions, classes, handleChange, handleSearch, loading } = props;
  const { materialId, clientCode } = controls;

  const { onChange, onSubmit, errors } = useForm(controls, null, {
    onChange: handleChange,
    validations: {
      materialId: [
        {
          check: (value) => !valueHasData(value) || isNumber(value),
          message: 'El código debe ser numérico ',
        },
        {
          check: (value) =>
            !valueHasData(value) ||
            numberBetween(value, 400_000, 499_999) ||
            numberBetween(value, 40_000_000, 49_999_999),
          message: 'Sólo códigos válidos entre 400000 y 499999 o entre 40000000 y 49999999',
        },
      ],
      clientCode: [
        {
          check: (value) => !valueHasData(value) || isNumber(value),
          message: 'El código de cliente debe ser numérico ',
        },
      ],
    },
  });

  const handleFilter = (e) => {
    e.preventDefault();
    onSubmit(() => {
      handleSearch();
    });
  };

  const handleDownLoadExcel = (data) => {
    downloadHistoric(data);
  };

  const exportExcel = () => {
    actions.getExcelData(
      {
        materialId: controls.materialId,
        clientCode: controls.clientCode,
        clientName: controls.clientName,
      },
      handleDownLoadExcel,
    );
  };

  // Every filter is optional for exporting: without them the whole history is exported.
  // useForm only validates the values the user actually typed.
  const handleExport = () => {
    onSubmit(exportExcel);
  };

  const handleChangeMaterialName = useCallback(
    (value) => {
      handleChange('materialId', value);
    },
    [handleChange],
  );

  const handleChangeClientName = useCallback(
    (value) => {
      handleChange('clientName', value);
    },
    [handleChange],
  );

  const handleClearSearch = () => {
    handleChange('materialId', '');
    handleChange('clientCode', '');
    handleChange('clientName', '');
    handleSearch();
  };

  return (
    <Grid container spacing={2}>
      <Grid item>
        <form onSubmit={handleFilter}>
          <Grid container spacing={1} wrap="nowrap" mb="20px">
            <Grid item>
              <TextField
                id="materialId"
                label="Filtrar por código material"
                variant="outlined"
                disabled={loading}
                value={materialId}
                onChange={onChange}
                error={errors.materialId?.length > 0}
                helperText={errors.materialId ? errors?.materialId[0] : null}
                inputProps={{ maxLength: 8 }}
              />
            </Grid>
            <Grid item mb="20px">
              <SearchMaterialByName
                historic
                materialId={controls.materialId}
                callback={handleChangeMaterialName}
                sx={{ width: 250 }}
              />
            </Grid>
            <Grid item>
              <TextField
                id="clientCode"
                label="Buscar por código Cliente"
                variant="outlined"
                disabled={loading}
                value={clientCode}
                onChange={onChange}
                error={errors.clientCode?.length > 0}
                helperText={errors.clientCode ? errors?.clientCode[0] : null}
                inputProps={{ maxLength: 12 }}
              />
            </Grid>
            <Grid item mb="20px">
              <SearchClientByName
                clientName={controls.clientName}
                callback={handleChangeClientName}
                sx={{ width: 250 }}
              />
            </Grid>
            <Grid item>
              <ButtonWithLoader
                type="submit"
                buttonId="search-quotes"
                variant="contained"
                color="primary"
                className={classes.button}>
                Filtrar
              </ButtonWithLoader>
            </Grid>
            <Grid item>
              <Button
                type="button"
                buttonId="clean-filter"
                variant="outlined"
                color="primary"
                className={classes.button}
                onClick={handleClearSearch}>
                Limpiar
              </Button>
            </Grid>
          </Grid>
        </form>
      </Grid>
      <Grid item>
        <ButtonWithLoader
          type="button"
          buttonId="get-excel-data"
          variant="outlined"
          color="primary"
          onClick={handleExport}
          startIcon={<FileDownloadIcon />}
          className={classes.button}>
          Exportar
        </ButtonWithLoader>
      </Grid>
    </Grid>
  );
};

export default HistoricFilters;
